<template>
  <div>
    <div>
      <div
        class="container"
        v-for="(item_group, index) in item_list"
        :key="item_group.code"
      >
        <div class="plans tab_service">
          <h2 class="ttl">
            {{ item_group.name }}
          </h2>
          <div v-if="item_group.list[0].code==='-'">
            <label class="plan basic-plan">
              <input type="radio" checked/>
              <div class="plan__content">
              <p class="plan__noselect">{{ item_group.list[0].name }}</p>
              </div>
            </label>
          </div>
          <div v-else>
          <label
            class="plan"
            v-for="(item, index) in item_group.list"
            :key="item.code"
            @click="
              $emit('click-Item', 'services', item_group.code, item.code, index)
            "
          >
            <input
              type="radio"
              :name="item_group.code"
              :value="item.code"
              v-model="check_value[item_group.code]"
            />
            <div class="plan__content">
              <div class="inner_box">
                <p class="plan__name">{{ item.name }}</p>
                <p class="plan__price">
                  <span>¥ {{ item.price }}</span>
                </p>
              </div>
            </div>
          </label>
          <label
            class="plan"
            @click="$emit('click-Item', 'services', item_group.code, '', -1)"
          >
            <input
              type="radio"
              :name="item_group.code"
              value=""
              v-model="check_value[item_group.code]"
            />
            <div class="plan__content">
              <p class="plan__noselect">選択しない</p>
            </div>
          </label>
          </div>
        </div>
        <div class="summaryArea" v-show="index === 0">
          <div class="summaryArea__header">
            <p class="title">各種延長保証について</p>
            <img
              @click="isVisible[index] = !isVisible[index]"
              src="../../public/images/service_arror_bottom.svg"
              v-bind:class="{ close: !isVisible[index] }"
            />
          </div>
          <div v-if="isVisible[index]" class="summaryArea__content">
            <p v-html="service_menu_url[0].detail.replace(/\n/g, '<br />')"></p>
            <a class="link__more" :href="item_group.url" target="_blank">
              > 延長プランについて詳細はこちら<img
                src="../../public/images/Vector.svg"
                class="inline-block_ml-2_w-5_h-5"
                alt=""
            /></a>
          </div>
        </div>
        <div class="summaryArea" v-show="index === 1">
          <div class="summaryArea__header">
            <p class="title">サービスプランについて</p>
            <img
              @click="isVisible[index] = !isVisible[index]"
              src="../../public/images/service_arror_bottom.svg"
              v-bind:class="{ close: !isVisible[index] }"
            />
          </div>
          <div v-if="isVisible[index]" class="summaryArea__content">
            <p v-html="service_menu_url[1].detail.replace(/\n/g, '<br />')"></p>
            <a class="link__more" :href="item_group.url" target="_blank">
              > 各種プランについて詳細はこちら<img
                src="../../public/images/Vector.svg"
                class="inline-block_ml-2_w-5_h-5"
                alt=""
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
import service_menu from "../functions/service_menu.json";

export default {
  props: ["item_list", "check_value"],
  setup(props) {
    const service_menu_url = service_menu.lists;
    const isVisible = reactive([]);
    for (var i = 0; i < props.item_list.length; i++) {
      isVisible[i] = true;
      const menu_url = service_menu_url.filter(
        (list) => list.name === props.item_list[i].name
      );
      props.item_list[i]["url"] = menu_url[0].url;
    }
    return {
      isVisible,
      service_menu_url,
    };
  },
};
</script>
<style scoped></style>
